// Module
var code = "<div class=\"spinner\"> <div v-for=\"number in [1, 2, 3]\" :key=\"number\" class=\"spinner_circle\"></div> </div> ";
// Exports
export default code;